import React, { createContext, useContext } from 'react';
const initialState = {
  variant: 'condensed',
  disabled: false
};
const AccordionContext = /*#__PURE__*/createContext(initialState);
export const AccordionContextProvider = ({
  children,
  variant,
  disabled
}) => {
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: {
      variant,
      disabled
    }
  }, children);
};
export const useAccordionContext = () => {
  return useContext(AccordionContext);
};